import usePressListingStore from 'layout/Listing/variants/press/store';

import { toKebabCase } from 'utils/strings';

const checkFilters = (press: { data: BlogResource }, filter: string) => {
  const tags = press.data?.tags?.map(tag => toKebabCase(tag || '')) || [];

  return filter === 'All' || tags.includes(toKebabCase(filter));
};

const useFilterPress = (allPress: { data: BlogResource }[]) => {
  const activeFilter = usePressListingStore(state => state.filters);
  const search = usePressListingStore(state => state.search);

  if (!activeFilter && !search) {
    return allPress;
  }

  const filteredPress = allPress.filter(press => {
    const isFiltered = checkFilters(press, activeFilter);

    return isFiltered;
  });

  const searchedEvents = filteredPress.filter(event =>
    event?.data?.title?.toLowerCase().includes(search.toLowerCase()),
  );

  return searchedEvents;
};

export default useFilterPress;
